import EL, { AbstractMethodError, MissingContainerError, RecursionLimitError } from '../model/EL/EL.js';
/** A generic interface for an EL element */
export default class IFACE {
    node;
    methods;
    events;
    handlers;
    setStopPropagation = true;
    setPreventDefault = true;
    /** Construct a generic Interface
        @param node Parent Element
        @param name Interface identifying name
    */
    constructor(node, name) {
        this.node = node;
        node.addClass(name);
        /** A collection of methods available on this interface*/
        this.methods = {};
        /** A collection of events available on this interface*/
        this.events = {};
        /** A collection of handlers available on this interface*/
        this.handlers = {};
        // Configuration and Setup
        this.setMethods(node);
        /** Configures Event Propagation and Default Behavior
            @param {Event} ev Event
        */
        this.methods.configureEvent = this.configureEvent.bind(node);
        this.addListeners(node);
    }
    /** Retrieves interface methods */
    getMethods() {
        return this.methods;
    }
    /** Configures Event Propagation and Default Behavior */
    configureEvent(ev) {
        if (this.setStopPropagation) {
            ev.stopPropagation();
        }
        if (this.setPreventDefault) {
            ev.preventDefault();
        }
    }
    /** Wraps the given function in a try/catch, catches TypeErrors and throws unknown Error
        @param {Function} fn Function to call
        @param {Event} event Event
        @param {string} message Error Message to display
    */
    onError(fn, event, message) {
        try {
            fn(event);
        }
        catch (e) {
            if (!(e instanceof TypeError)) {
                console.warn(message, e);
                throw e;
            }
        }
    }
    /** Toggles state of this element (by className) and triggers the appropriate event
        @param {string} className Existence of classname indicates on/off event to call
        @param {Event} eventOn Event to call if class does not yet exist
        @param {Event} eventOff Event to call if class already exists
    */
    toggle(className, eventOn, eventOff) {
        return this.node.chain(() => this.node.do(this.node.hasClass(className) ? eventOff : eventOn));
    }
}
export { AbstractMethodError, EL, MissingContainerError, RecursionLimitError };
